import { Fragment, useState, useEffect, useCallback } from "react";
import CustomLabel from "../shared/label/custom-label.component";
import OrderSummaryProductList from "../order-summary-product-list/order-summary-product-list.component";
import OrderSummaryPricing from "../order-summary-pricing/order-summary-pricing.component";
import { netural50 } from "../../utils/colors";
const OrderSummary = ({
  products,
  itemType,
  pricing,
  selectedCheckoutCart,
  promotionalCode,
  applyReferral,
  fulfillmentOption,
  isDataNormalized = true,
}) => {
  const [pickupOrders, setPickupOrders] = useState({});
  const [deliveryOrders, setDeliveryOrders] = useState([]);
  // :white_check_mark: Memoized normalizeData
  const normalizeData = useCallback((data) => {
    return data.map((item) => ({
      _id: item._id,
      title: item.title,
      price: item.price,
      discountedPrice: item.discountedPrice,
      uri: item.uri,
      quantity: item.quantity,
      variantCombination: item.variantCombination,
      fulfillmentOptions: {
        pickup:
          item.fulfillmentOption?.type === "pickup"
            ? {
                enabled: true,
                pickupAddress: { address: item.fulfillmentOption.address },
              }
            : null,
        delivery:
          item.fulfillmentOption?.type === "delivery"
            ? { enabled: true }
            : null,
      },
    }));
  }, []);
  // :white_check_mark: Memoized group function
  const groupProductsByPickupLocation = useCallback(
    (products) => {
      return products.reduce(
        (acc, product) => {
          const isPickupEnabled = fulfillmentOption === "pickup";
          const isDeliveryEnabled = fulfillmentOption === "delivery";
          if (isPickupEnabled) {
            const pickupAddress =
              product.fulfillmentOptions?.pickup?.pickupAddress?.address ||
              "No Pickup Location";
            if (!acc.pickup[pickupAddress]) {
              acc.pickup[pickupAddress] = [];
            }
            acc.pickup[pickupAddress].push(product);
          } else if (isDeliveryEnabled) {
            acc.delivery.push(product);
          }
          return acc;
        },
        { pickup: {}, delivery: [] }
      );
    },
    [fulfillmentOption]
  );
  // :white_check_mark: useEffect for grouping
  useEffect(() => {
    if (itemType === "product") {
      const normalizedProducts = isDataNormalized
        ? products
        : normalizeData(products);
      const { pickup, delivery } =
        groupProductsByPickupLocation(normalizedProducts);
      setPickupOrders(pickup);
      setDeliveryOrders(delivery);
    }
  }, [
    itemType,
    products,
    isDataNormalized,
    normalizeData,
    groupProductsByPickupLocation,
  ]);
  return (
    <Fragment>
      <CustomLabel style={{ fontSize: "18px", fontWeight: "bold" }}>
        {itemType === "service" ? "Booking summary" : "Order summary"}
      </CustomLabel>
      <div
        style={{
          maxHeight: "30vh",
          overflowY: "auto",
        }}
        className="mt-3"
      >
        {itemType === "autoship" || itemType === "service" ? (
          products.map((product, index) => (
            <OrderSummaryProductList
              key={index}
              product={product}
              index={index}
              itemType={itemType}
            />
          ))
        ) : (
          <>
            {Object.entries(pickupOrders).map(
              ([pickupAddress, group], index) => (
                <div
                  key={index}
                  className="mb-4"
                  style={{
                    border: "solid 1px #DADADA",
                    borderRadius: "16px",
                  }}
                >
                  <div
                    style={{
                      fontWeight: "bold",
                      marginBottom: "5px",
                      display: "flex",
                      flexDirection: "column",
                      backgroundColor: netural50,
                      borderTopLeftRadius: "16px",
                      borderTopRightRadius: "16px",
                      padding: "3%",
                    }}
                  >
                    <CustomLabel style={{ fontWeight: 600 }}>
                      Pickup at:
                    </CustomLabel>
                    <CustomLabel style={{ fontWeight: "normal" }}>
                      {pickupAddress}
                    </CustomLabel>
                  </div>
                  {group.map((product, idx) => (
                    <OrderSummaryProductList
                      key={idx}
                      product={product}
                      index={idx}
                      itemType={itemType}
                    />
                  ))}
                </div>
              )
            )}
            {deliveryOrders.length > 0 &&
              deliveryOrders.map((product, index) => (
                <OrderSummaryProductList
                  key={index}
                  product={product}
                  index={index}
                  itemType={itemType}
                />
              ))}
          </>
        )}
      </div>
      <div style={{ borderTop: "1px solid #DADADA", marginTop: "5%" }}></div>
      <OrderSummaryPricing
        itemType={itemType}
        pricing={pricing}
        selectedCheckoutCart={selectedCheckoutCart}
        promotionalCode={promotionalCode}
        applyReferral={applyReferral}
      />
    </Fragment>
  );
};
export default OrderSummary;
